import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationCenterService } from '../modules/notification-center/notification-center.service';
import { ScrollService } from './scroll.service';
import { CustomNotificationCenterService } from '../modules/notification-center/custom-notification-center.service';

@Injectable({
  providedIn: 'root',
})
export class ReloadBonusesService {

  private _notify = inject(CustomNotificationCenterService);
  private _router = inject(Router);
  private _scroll = inject(ScrollService);

  public activeReloadBonuses = signal(
    this._notify.getActiveReloadBonusNotification(),
  );

  public async onChooseBonus(selectedBonusCode: string, resetScroll?: boolean) {
    this.activeReloadBonuses.update(bonuses =>
      bonuses.map((bonus, i) => ({
        ...bonus,
        active: bonus.bonusCode === selectedBonusCode,
      })),
    );
    await this._router.navigate(['account', 'deposit'], {
      queryParams: {
        bonusCode: selectedBonusCode || null,
      },
      replaceUrl: true
    }).then(() => {
      if (resetScroll) {
        setTimeout(() => {
          this._scroll.scrollToElement(this._scroll.documentElement, 600, true, 400);
        })
      }
    });
  }

  public onClearSelectedBonuses() {
    this.activeReloadBonuses.update(bonuses =>
      bonuses.map((bonus, idx) => ({
        ...bonus,
        active: false,
      })),
    );
  }

}
